module.exports = __webpack_public_path__ + "static/media/favorite-active.0190f81c.svg";